import { render, staticRenderFns } from "./organization-control-card.vue?vue&type=template&id=67b45e66&scoped=true&"
import script from "./organization-control-card.vue?vue&type=script&lang=js&"
export * from "./organization-control-card.vue?vue&type=script&lang=js&"
import style0 from "./organization-control-card.vue?vue&type=style&index=0&id=67b45e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b45e66",
  null
  
)

export default component.exports